import "./ForecastStrip.css";

function toF(c) {
  return Math.round((c * 9) / 5 + 32);
}

function formatDay(timestamp) {
  const date = new Date(timestamp * 1000);
  const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  return days[date.getDay()];
}

export default function ForecastStrip({ forecast, unit }) {
  const days = forecast.slice(1, 7); // skip today

  return (
    <div className="forecast-strip">
      {days.map((day, index) => {
        const hi = unit === "C" ? Math.round(day.temperature.maximum) : toF(day.temperature.maximum);
        const lo = unit === "C" ? Math.round(day.temperature.minimum) : toF(day.temperature.minimum);

        return (
          <div className="forecast-day" key={index}>
            <p className="day-name">{formatDay(day.time)}</p>
            <img
              src={`http://shecodes-assets.s3.amazonaws.com/api/weather/icons/${day.condition.icon}.png`}
              alt={day.condition.description}
            />
            <div className="forecast-temps">
              <span className="f-hi">{hi}°</span>
              <span className="f-lo">{lo}°</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
